import React from 'react';
import '../../styles/AdminPages.css';

const Products = () => {
  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <h1>Products Management</h1>
        <p>Manage your products inventory</p>
      </div>
      
      <div className="admin-card">
        <div className="admin-table-header">
          <button className="admin-button primary">Add New Product</button>
          <div className="admin-search-box">
            <input type="text" placeholder="Search products..." />
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
          </div>
        </div>
        
        <div className="admin-table-container">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Category</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
                  No products found
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Products;

